export const SET_USER_MESSAGE = "SET_USER_MESSAGE";
export const CLEAR_USER_MESSAGE = "CLEAR_USER_MESSAGE";
